<script setup>
import { ref, computed, defineAsyncComponent } from 'vue'
import { useGlobalStore } from '@stores/global'
import { useSubmissionStore } from '@stores/submission'
import UploadButton from '@components/global/forms/UploadButton.vue'

const global = useGlobalStore()
const submission = useSubmissionStore()

const activePlatform = ref(0)

const close = () => {
	if (!submission.fileUploading) {
		global.closeModal()
	}
}
</script>

<template>
	<div class="fixed z-50 flex h-full w-full items-center justify-center">
		<div class="absolute h-full w-full bg-black/50 backdrop-blur-sm" @click="close"></div>
		<div class="modal relative z-[60] m-5 flex w-full max-w-5xl flex-col gap-10 overflow-y-auto border border-[#292828] bg-[#141414] bg-halftone-pattern bg-[auto_300px] bg-right-top bg-no-repeat p-10 md:flex-row">
			<transition name="fade" mode="out-in">
				<button class="group absolute right-2 top-2 flex h-14 w-14 items-center justify-center" @click="close" v-if="!submission.fileUploading" :key="submission.fileUploading">
					<i class="fas fa-xmark text-3xl text-fury-orange-500 transition-colors duration-200 group-hover:text-white" />
				</button>
			</transition>
			<div class="flex w-full flex-col items-center gap-2">
				<div class="font-aktiv-grotesk-cd text-sm font-medium uppercase">Examples of how your screenshot should look:</div>
				<div class="flex w-full gap-2">
					<button :class="['relative flex h-14 w-full items-center justify-center border border-[#3F3F3F] transition-colors duration-200', i == activePlatform ? 'bg-white' : 'bg-[#141414]']" v-for="(platform, i) in global.platforms" @click="activePlatform = i">
						<div class="absolute left-1 top-1 h-2 w-2 bg-black [clip-path:polygon(0%_0%,0%_100%,100%_0%)]" v-if="i == activePlatform"></div>
						<i :class="['text-3xl transition-colors duration-200', platform.fa_icon, i == activePlatform ? 'text-black' : 'text-white']" v-if="platform.fa_icon" />
						<img :class="['h-8 transition-all duration-200', { 'brightness-[0]': i == activePlatform }]" :src="platform.icon" alt="" />
					</button>
				</div>
				<transition name="fade" mode="out-in">
					<img :src="global.platforms[activePlatform].example" alt="Platform Example" :key="activePlatform" />
				</transition>
			</div>
			<div class="order-first flex w-full flex-col justify-between pt-5 md:order-last">
				<div class="flex flex-col gap-10">
					<i class="fal fa-triangle-exclamation text-4xl" />
					<div class="flex flex-col gap-5">
						<div class="font-shuttleblock-cd text-4xl font-black uppercase text-fury-orange-500">Screenshot Instructions</div>
						<div class="font-aktiv-grotesk-cd text-lg font-medium">Upon ordering the game, you will receive a purchase confirmation email. Make sure your screenshot is legible and your order number in the screenshot matches the provided order number.</div>
					</div>
				</div>
				<UploadButton />
			</div>
		</div>
	</div>
</template>

<style scoped>
.modal {
	max-height: calc(100svh - 2.5rem);
}
</style>
